<div class="engagement-panel">
  @if (openUserAddPopup) {
    <kendo-popup
      (close)="close()"
      [animate]="animate"
      [anchor]="anchor"
      [anchorAlign]="anchorAlign"
      [popupAlign]="popupAlign"
      popupClass="full-height-popup"
      [margin]="margin">
      <div #popupContent  class="add-client-container">
        <div class="popup-header">
          <div class="popup-title">User Request</div>
          <button class="close-btn" (click)="close()">&#x2715;</button>
        </div>
        <div>
          @if (isDisplayloader) {
            <div class="setloader-position"
              >
              <ngx-spinner bdColor="rgba(0, 0, 0, 0.1)"
                size="default"
                color="#225EFF"
                type="ball-triangle-path" [fullScreen]="false">
              </ngx-spinner>
            </div>
          }
          @if (!isDisplayloader) {
            <div class="engagement-details-section">
              @if (userAddRequestForm) {
                <form class="k-form k-form-md" [formGroup]="userAddRequestForm">
                  <div class="wrapper">
                    <kendo-card class="k-custom-card w-100">
                      <kendo-card-header class="k-custom-card-header">
                        <div>
                          <h3 kendoCardTitle>Name</h3>
                        </div>
                      </kendo-card-header>
                      <kendo-card-body class="k-card-body k-custom-card-body">
                        <!-- <div> -->
                        <div>
                          <h4 style="margin-bottom:0px"> {{userDetail?.name}}</h4>
                        </div>
                      <!-- </div> -->
                    </kendo-card-body>
                  </kendo-card>
                  <kendo-card class="k-custom-card w-100">
                    <kendo-card-header class="k-custom-card-header">
                      <div>
                        <h3 kendoCardTitle>Engagement</h3>
                      </div>
                    </kendo-card-header>
                    <kendo-card-body class="k-card-body k-custom-card-body">
                      <!-- <div> -->
                      <div>
                        <h4 style="margin-bottom:0px"> {{userDetail?.engagementName}}</h4>
                      </div>
                    <!-- </div> -->
                  </kendo-card-body>
                </kendo-card>
                <kendo-card class="k-custom-card w-100">
                  <kendo-card-header class="k-custom-card-header">
                    <div>
                      <h3 kendoCardTitle>Role</h3>
                    </div>
                  </kendo-card-header>
                  <kendo-card-body class="k-custom-card-body">
                    <div>
                      <h4 style="margin-bottom: 0px;"> {{userDetail?.userRequestRoleTypeName}} </h4>
                    </div>
                  </kendo-card-body>
                </kendo-card>
                <kendo-card class="k-custom-card w-100">
                  <kendo-card-header class="k-custom-card-header">
                    <div>
                      <h3 kendoCardTitle>Activity Stream</h3>
                    </div>
                  </kendo-card-header>
                  @if (userDetail?.activityStream) {
                    <kendo-card-body class="k-custom-card-body k-card-body">
                      <kendo-timeline [events]="userDetail?.activityStream"
                        [collapsibleEvents]="false"
                        [alterMode]="false">
                      </kendo-timeline>
                    </kendo-card-body>
                  }
                </kendo-card>
                @if (((isApprovalUser && requestStatus === RequestStatusEnum.Pending) || (!isApprovalUser && requestStatus !== RequestStatusEnum.Completed && requestStatus !== RequestStatusEnum.Rejected))) {
                  <div>
                    <kendo-label text="Comments " style="color: black;">
                      <span style="color:#757575;"><i>(Optional)</i></span>
                    </kendo-label>
                    @if (isApprovalUser) {
                      <kendo-textarea placeholder="Comments"
                        formControlName="approvalUserComment"
                        fillMode="none"
                        class="custom-textarea"
                        [rows]="3"
                      resizable="vertical" [maxlength]="256"></kendo-textarea>
                    }
                    @if (!isApprovalUser) {
                      <kendo-textarea placeholder="Comments"
                        formControlName="supportUserComment"
                        fillMode="none"
                        class="custom-textarea"
                        [rows]="3"
                        resizable="vertical"
                      [ngClass]="{'completed': message !== ''}"  [maxlength]="256"></kendo-textarea>
                    }
                  </div>
                }
              </div>
            </form>
          }
          <div>
            @if (message !== '') {
              <h4 style="color: red">{{ message }}</h4>
            }
          </div>
        </div>
      }
      @if (!isDisplayloader && isApprovalUser) {
        <div class="form-buttons">
          <button kendoButton type="button" themeColor="none" (click)="approveUserRequest()" class="request-button" [disabled]="requestStatus !== RequestStatusEnum.Pending">APPROVE</button>
          <button kendoButton type="button" themeColor="none" (click)="denyUserRequest()" style="width: 100%;background-color: orange;font-weight: 600;" [disabled]="requestStatus !== RequestStatusEnum.Pending">DENY</button>
          <button kendoButton type="button" (click)="cancelUserRequest()" style="width: 100%;margin-left: 10px;color: gray;font-weight: 600;">REVIEW LATER</button>
        </div>
      }
      @if (!isDisplayloader && !isApprovalUser) {
        <div class="form-buttons">
          <button kendoButton type="button" (click)="addUserRequest()" class="request-button" [disabled]="requestStatus === RequestStatusEnum.Completed || requestStatus === RequestStatusEnum.Rejected" themeColor="none" [ngClass]="{'completed-request-button': message !== ''}">ADD</button>
          <button kendoButton type="button" (click)="cancelUserRequest()" class="w-100">CANCEL</button>
        </div>
      }
    </div>
  </div>
</kendo-popup>
}
</div>

@if (openUserAddPopup) {
  <div class="k-popup-backdrop"></div>
}





